import type { InterventionMenuTreeItemDescriptionProps } from "./intervention-menu-tree-item-description.type";

import { DeploymentUnitOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import { useTranslation } from "react-i18next";

import {
  getInterventionSectionAsset,
  isLoopOnChildrenSection,
} from "@/modules/intervention/intervention-section";
import { MODEL_KEY } from "@/modules/model";
import ModelIcon from "@/modules/model-icon";
import { InfoWithIcon } from "@/ui/info-with-icon";

const InterventionMenuTreeItemDescription = ({
  menuItem,
}: InterventionMenuTreeItemDescriptionProps) => {
  const section = menuItem.data;
  const { t } = useTranslation();

  if (!section || !isLoopOnChildrenSection(section)) return null;

  const sectionName = section.name;
  const asset = getInterventionSectionAsset(section);
  const assetTypeName = asset?.asset_type?.name;

  return (
    <Flex className="intervention-menu-tree-item-description">
      <InfoWithIcon
        text={sectionName}
        tooltip={t("intervention:menu.loopOnChildrenTooltip", {
          sectionName,
        })}
        icon={<DeploymentUnitOutlined />}
      />
      {assetTypeName && (
        <InfoWithIcon
          text={assetTypeName}
          tooltip={t("intervention:menu.assetTypeTooltip", {
            assetType: assetTypeName,
          })}
          icon={<ModelIcon model={MODEL_KEY.ASSETTYPE} />}
        />
      )}
    </Flex>
  );
};

export default InterventionMenuTreeItemDescription;
